import GroupsListContainer from './GroupsListContainer';

export default GroupsListContainer;
